var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("default"),(_vm.globalErrorMessage !== '')?_c('div',{staticClass:"error-input my-2"},[_vm._v(" "+_vm._s(_vm.globalErrorMessage)+" ")]):_vm._e(),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }